import { useCallback } from "react";

import type { BillingStatusUpdateInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { HOTEL_APPLICATION_DATA_MUTATION } from "./schema";
import { START_GUIDE_QUERY } from "../../start-guide/query/schema";
import { HOTEL_APPLICATION_DATA_QUERY } from "../query/schema";

export const useHotelApplicationDataMutation = () => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const { mutationFunc } = useCustomMutation(HOTEL_APPLICATION_DATA_MUTATION);

	const onUpdateHotelApplicationData = useCallback(
		async (input: BillingStatusUpdateInput) => {
			showLoadingScreenCallback();
			const { errors } = await mutationFunc({
				variables: { input },
				refetchQueries: [
					{ query: HOTEL_APPLICATION_DATA_QUERY, variables: { hotelID: input.hotelID } },
					{ query: START_GUIDE_QUERY, variables: { hotelID: input.hotelID } },
				],
			}).finally(() => hideLoadingScreenCallback());

			if (errors && errors.length) {
				return false;
			} else {
				return true;
			}
		},
		[mutationFunc, showLoadingScreenCallback, hideLoadingScreenCallback],
	);

	return { onUpdateHotelApplicationData };
};
